import React from "react";
import { useDispatch, useSelector } from "react-redux";

import t from "../../../../Common/utils/translation/translator";

import Spinner from "../../../../Common/components/Icons/Spinner/Spinner";

import AxisSelectionFilterAxisTypeSection from "./AxisSelectionFilterAxisTypeSection";
// import AxisSelectionFilterEndSection from "./AxisSelectionFilterEndSection";
import AxisSelectionFilterMiddleSection from "./AxisSelectionFilterMiddleSection";
import AxisSelectionFilterProductTypeSection from "./AxisSelectionFilterProductTypeSection";

import { selectDefaultFilters, selectCartesianPossibleFiltersValues } from "../../../store/slices/cartesian";

const AxisSelectionFilterFiltersSection = ({
  onClose,
  refetchAxesCombinations,
  dependencies,
  isLoadingDependencies,
  isFetchingDependencies,
  resetAxesToCompare,
  setCartesianFilters,
  cartesianFilters
}) => {
  const dispatch = useDispatch();

  const defaultFilters = useSelector(selectDefaultFilters);
  const cartesianPossibleFiltersValues = useSelector(selectCartesianPossibleFiltersValues);

  // Function to handle changes in the selection
  const handleProductTypeChange = (newProductTypes) => {
    // Check if the new selection is different from the current one
    const isNewSelectionDifferent =
      JSON.stringify(newProductTypes) !== JSON.stringify(cartesianFilters.axisFilter.axisType);

    if (isNewSelectionDifferent) {
      // Only update the filters if the new selection is different
      const updatedAxisFilter = {
        ...cartesianFilters,
        axisFilter: {
          ...cartesianFilters.axisFilter,
          axisType: newProductTypes?.length > 0 ? newProductTypes : undefined
        }
      };

      dispatch(setCartesianFilters(updatedAxisFilter));
    }
  };

  // const handleAxisPerformanceChange = (newAxisPerformance) => {
  //   console.log(newAxisPerformance);
  //   // setFilters((prevFilters) => ({
  //   //   ...prevFilters,
  //   //   axisPerformanceFilter: newAxisPerformance
  //   // }));
  // };

  const handleClearFilters = () => {
    dispatch(setCartesianFilters(defaultFilters));
  };

  const handleApplyFilters = () => {
    dispatch(resetAxesToCompare());
    refetchAxesCombinations();
    onClose();
  };

  return (
    <div className="bg-gray-10 drop-shadow border-l-4 border-l-primary p-3">
      {(isLoadingDependencies || isFetchingDependencies) && (
        <div className="absolute top-0 left-0 w-full h-full bg-white bg-opacity-50 flex items-center justify-center">
          <Spinner />
        </div>
      )}
      <div className="flex flex-col space-y-5">
        <div className="flex justify-start">
          <AxisSelectionFilterAxisTypeSection
            isLoadingOrFetchingGetAxesCombinations={isLoadingDependencies || isFetchingDependencies}
            cartesianFilters={cartesianFilters}
            dependencies={dependencies}
            setCartesianFilters={setCartesianFilters}
          />
          <AxisSelectionFilterProductTypeSection
            cartesianPossibleFiltersValues={cartesianPossibleFiltersValues}
            onProductTypeChange={handleProductTypeChange}
            cartesianFilters={cartesianFilters}
            dependencies={dependencies}
          />
          <AxisSelectionFilterMiddleSection
            cartesianPossibleFiltersValues={cartesianPossibleFiltersValues}
            dependencies={dependencies}
            setCartesianFilters={setCartesianFilters}
            cartesianFilters={cartesianFilters}
          />
          {/* <AxisSelectionFilterEndSection onAxisPerformanceChange={handleAxisPerformanceChange} /> */}
        </div>
        <div className="items-center justify-center flex flex-row space-x-2">
          <qds-button
            onClick={handleApplyFilters}
            importance="emphasized"
            text={t("cartesian.ui.axis_selection.apply-button")}
          />

          <qds-button onClick={handleClearFilters} text={t("cartesian.ui.axis_selection.clear-filters")} />
          {/* <div className="absolute right-4">
            Axes combinations (
            {dependencies?.applicationData?.countOfAxisCombinations !== undefined
              ? dependencies?.applicationData?.countOfAxisCombinations
              : "..."}
            )
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default AxisSelectionFilterFiltersSection;
